import { put, fork, takeLatest, call } from "redux-saga/effects";
import { notification } from "antd";

import {
    constants as SponsorsDashboardConstants,
    actions as SponsorsDashboardActions,
} from "../actions/dashboard-sponsors-actions";
import { actions as homeActions } from "../actions/home-actions";
import {
    getAll,
    update,
    get
} from "../../api/module/sponsorDashboard";

export function* getSponsorDashboardSagas({ payload }) {
    yield put(homeActions.setLoading(true));

    try {
        const response = yield call(getAll);

        if (response.status === 200) {
            if (payload.callback) {
                payload.callback()
            }

            yield put(homeActions.setLoading(false));
            yield put(SponsorsDashboardActions.setSponsorsDashboard(response.data.sponsors));
        }
    } catch (error) {
        console.log(error);
        yield put(homeActions.setLoading(false));
    }
}

export function* getSponsorDashboardCasesSagas({ payload }) {
    yield put(homeActions.setLoading(true));

    try {
        const response = yield call(get,payload.data);

        if (response.status === 200) {
            if (payload.callback) {
                payload.callback()
            }

            yield put(homeActions.setLoading(false));
            yield put(SponsorsDashboardActions.setSponsorsDashboardSegment({
                id: payload.data.uniqueLink,
                cases: payload.data.cases,
                obj:response.data.data
            }));
        }
    } catch (error) {
        console.log(error);
        yield put(homeActions.setLoading(false));
    }
}

export function* updateSponsorDashboardSagas({ payload }) {
    yield put(homeActions.setLoading(true));

    try {
        const response = yield call(update, payload.data);

        if (response.status === 200) {
            if (payload.callback) {
                payload.callback()
            }

            yield put(homeActions.setLoading(false));
            notification.info({
                message: "SponsorDashboard was updated successfully.",
            });
        }
    } catch (error) {
        console.log(error);
        yield put(homeActions.setLoading(false));
    }
}


function* watchLogin() {
    yield takeLatest(SponsorsDashboardConstants.GET_SPONSORS_DASHBOARD, getSponsorDashboardSagas);
    yield takeLatest(SponsorsDashboardConstants.GET_SPONSORS_DASHBOARD_CASES, getSponsorDashboardCasesSagas)
    yield takeLatest(SponsorsDashboardConstants.UPDATE_SPONSORS_DASHBOARD, updateSponsorDashboardSagas);
}

export const sponsorDashboardSaga = [fork(watchLogin)];
